import z from 'zod';

export const credentialScopeSchema = z.object({
	resourceType: z.string().optional(),
	resourceId: z.string().optional(),
	action: z.string().optional(),
});

export const credentialSchema = z
	.object({
		id: z.string(),
		userId: z.string(),
		params: z.any().optional(),
		validFrom: z.coerce.date().optional(),
		validTo: z.coerce.date().optional(),
		loginAttempts: z.number().default(0),
		lastLoginAttempt: z.coerce.date().optional(),
		scope: credentialScopeSchema.optional(),
	})
	.describe('Credential');
